// extracted by mini-css-extract-plugin
export default {"no_underline":"Login_no_underline__h0eIS","logo_img":"Login_logo_img__Kki1U"};